<template>
    <v-flex xs12 mb-10 mx-2 pb-5>
      <lister
        style="height: 100%"
        :items="orderedFiles"
        cardBreakpoints="xs12 md6 lg4"
        searchPlaceholder="Buscar por título"
        emptyListMessage="Nenhum arquivo cadastrado..."
        emptySearchMessage="Nenhum conteúdo encontrado..."
        :autosort="false"
      >
        <template v-slot:default="slotProps">
          <file-tile
            @deletion="deleteFile($event)"
            :file="slotProps.item"
            :deletingFile="errorDialog ? null: deletingFile"
          />
        </template>
      </lister>
      <v-btn fixed dark fab right bottom color="primary" @click="$emit('click')">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <error-dialog
      v-if="errorDialog && deletingFile"
      :title="'Erro'"
      :enabled="errorDialog"
      :dialogColor="'error'"
      :confirmationButtonColor="'error'"
      :confirmationButtonMessage="'Tentar novamente'"
      :confirmationMessage="errorDialogMessage"
      @abort="errorDialogAction(false)"
      @confirm="errorDialogAction(true)"
    />
    </v-flex>

    
</template>

<script>
import Lister from "@/components/Lister";
import FileTile from "./FileTile";
import filesDeletion from '@/mixins/filesDeletion.js'
import ErrorDialog from "@/components/templates/ConfirmationDialog";

export default {
  components: { FileTile, Lister, ErrorDialog },
  mixins: [filesDeletion],
  props: {
    files: Array
  },
  computed: {
    orderedFiles() {
      let filesCopy = [];
      if (this.files) {
        filesCopy = this.files.slice();
        filesCopy.sort((a, b) => a.title.localeCompare(b.title));
      }
      return filesCopy;
    },
  }
};
</script>
